__turbopack_context__.v({
  "container": "ResultsTeaser-module-scss-module__SQrJdW__container",
  "grid": "ResultsTeaser-module-scss-module__SQrJdW__grid",
  "headlineNumber": "ResultsTeaser-module-scss-module__SQrJdW__headlineNumber",
});
